import type { WorkflowDefinition } from '../../api/workflowRuns'
import { resolveWorkflowDefinitionDisplay } from '../../lib/workflow/workflowDefinitionDisplay'
import { workflowDefinitionStatusLabel } from '../../lib/workflow/workflowDisplay'
import { ChromePrimaryButton, ChromeToolbarButton } from '../ChromeActions'
import { chromeMetaTagClass } from '../ChromeSurface'

type Props = {
  definition: WorkflowDefinition
  angular: boolean
  busy?: boolean
  onRun?: (definition: WorkflowDefinition) => void
  onOpenBuilder?: (definition: WorkflowDefinition) => void
  onQuickSimulate?: (definition: WorkflowDefinition) => void
  onClone?: (definition: WorkflowDefinition) => void
}

export function WorkflowSystemTemplateCard({
  definition,
  angular,
  busy,
  onRun,
  onOpenBuilder,
  onQuickSimulate,
  onClone,
}: Props) {
  const display = resolveWorkflowDefinitionDisplay(definition)
  const nodeCount = definition.graph?.nodes?.length ?? 0
  const edgeCount = definition.graph?.edges?.length ?? 0

  return (
    <article
      className={[
        'flex min-w-0 flex-col border-line bg-panel text-ink shadow-card',
        angular ? 'rounded-none border-2' : 'rounded-theme border',
      ].join(' ')}
    >
      <div className="flex min-h-0 flex-1 flex-col gap-2 px-3 py-3 sm:px-3.5">
        <div className="flex flex-wrap items-center gap-1.5">
          <span className={chromeMetaTagClass(angular, 'outline')}>系统模板</span>
          <span className={chromeMetaTagClass(angular, 'solid', { hint: true })}>{display.typeLabel}</span>
          <span className={chromeMetaTagClass(angular, 'solid')}>
            {workflowDefinitionStatusLabel(definition.status)}
          </span>
        </div>
        <h2 className="text-sm font-semibold leading-snug text-ink">{display.name}</h2>
        <p className="line-clamp-3 text-xs leading-relaxed text-ink-soft">
          {display.description || '平台内置工作流模板'}
        </p>
        <p className="text-xs text-ink-soft">
          {nodeCount} 节点 · {edgeCount} 连线
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-end gap-2 border-t border-line px-3 py-2 sm:px-3.5">
        {onRun ? (
          <ChromePrimaryButton type="button" density="compact" className="!h-8" disabled={busy} onClick={() => onRun(definition)}>
            运行
          </ChromePrimaryButton>
        ) : null}
        {onOpenBuilder ? (
          <ChromeToolbarButton type="button" className="!h-8" disabled={busy} onClick={() => onOpenBuilder(definition)}>
            编排
          </ChromeToolbarButton>
        ) : null}
        {onQuickSimulate ? (
          <ChromeToolbarButton type="button" className="!h-8" disabled={busy} onClick={() => onQuickSimulate(definition)}>
            模拟
          </ChromeToolbarButton>
        ) : null}
        {onClone ? (
          <ChromeToolbarButton type="button" className="!h-8" disabled={busy} onClick={() => onClone(definition)}>
            复制到我的
          </ChromeToolbarButton>
        ) : null}
      </div>
    </article>
  )
}
